import React, { useEffect } from "react";
import './styleintro.css'
import $ from 'jquery'
import jQuery from "jquery";
// image
import soluimg from '../ADHIBAWEBSITE-HOSTED/font/Innovation-01.png'
import soluimg2 from '../ADHIBAWEBSITE-HOSTED/font/Scalability-01.png'
import soluimg3 from '../ADHIBAWEBSITE-HOSTED/font/Reliability-01.png'
import ptzcam from '../ADHIBAWEBSITE-HOSTED/font/ptz.png'
import iconsto from '../ADHIBAWEBSITE-HOSTED/font/menu_3754921.png'
import icontec from '../ADHIBAWEBSITE-HOSTED/font/innovation_7266451.png'
import iconblog from '../ADHIBAWEBSITE-HOSTED/font/form_6868790.png'
import iconsolu from '../ADHIBAWEBSITE-HOSTED/font/jigsaw_2140209.png'
import iconpro from '../ADHIBAWEBSITE-HOSTED/font/product-development_5998199.png'
import adhibalogo from '../ADHIBAWEBSITE-HOSTED/font/adhiba.png'
import div from '../ADHIBAWEBSITE-HOSTED/font/4983.jpg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobile, faEnvelope, faBlog } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faYoutube } from '@fortawesome/free-brands-svg-icons';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faTwitter } from '@fortawesome/free-brands-svg-icons';
import { faFacebook } from '@fortawesome/free-brands-svg-icons';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons';

import letmakesomimg1 from "../ADHIBAWEBSITE-HOSTED/font/packing.png"
import letmakesomimg2 from "../ADHIBAWEBSITE-HOSTED/font/agreement.png"
import letmakesomimg3 from "../ADHIBAWEBSITE-HOSTED/font/idea.png"
import letmakesomimg4 from "../ADHIBAWEBSITE-HOSTED/font/manufacturing.png"
import letmakesomimg5 from "../ADHIBAWEBSITE-HOSTED/font/key (1).png"

import Tabs from "./scroll";
import Footer from "./footer";
import Productcardcar from "./product";
import NysCaro from "./Ncaro (1)";
import Timeline from "./timeline.js";
import AdvancedTimeline from "./NEW-TIMELINE/newtimeline.js";
import Newtimeline from "./NEW-TIMELINE/newtimeline.js";
import adhibaban from "../ADHIBAWEBSITE-HOSTED/IMAGES-ADHIBA/vecteezy_smart-city-and-network-communication-and-data_8094576.jpg"

export default function Finaladhiba() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  (function ($) {
    "use strict";

    $(document).ready(function () {

      $('.slide-buttons li:nth-child(1)').on('mouseenter', function () {
        $('.slide-buttons li.active').removeClass('active');
        $('.hero-center-section.show').removeClass("show");
        $('.hero-center-section:nth-child(1)').addClass("show");
        $('.slide-buttons li:nth-child(1)').addClass('active');
      })
      $('.slide-buttons li:nth-child(2)').on('mouseenter', function () {
        $('.slide-buttons li.active').removeClass('active');
        $('.hero-center-section.show').removeClass("show");
        $('.hero-center-section:nth-child(2)').addClass("show");
        $('.slide-buttons li:nth-child(2)').addClass('active');
      })
      $('.slide-buttons li:nth-child(3)').on('mouseenter', function () {
        $('.slide-buttons li.active').removeClass('active');
        $('.hero-center-section.show').removeClass("show");
        $('.hero-center-section:nth-child(3)').addClass("show");
        $('.slide-buttons li:nth-child(3)').addClass('active');
      })
      $('.slide-buttons li:nth-child(4)').on('mouseenter', function () {
        $('.slide-buttons li.active').removeClass('active');
        $('.hero-center-section.show').removeClass("show");
        $('.hero-center-section:nth-child(4)').addClass("show");
        $('.slide-buttons li:nth-child(4)').addClass('active');
      })
      $('.slide-buttons li:nth-child(1)').trigger('mouseenter')

    });

  })(jQuery);

  // Optional, if you want to make the text running
  let percent = 70;
  let counter = 1;
  let intervalID = null;
  $(document).ready(() => {
    intervalID = setInterval(updateNumber, 100);
  });

  // Update the number
  function updateNumber() {
    let step = 5;
    if (counter + step >= percent) {
      counter = percent;
      $('#percentage').html(counter + 'k');
      clearInterval(intervalID);
      return;
    }
    counter += step;
    $('#percentage',).html(counter + 'k');
  }

  // Optional, if you want to make the text running
  let percent2 = 15;
  let counter2 = 2;
  let intervalID2 = null;
  $(document).ready(() => {
    intervalID2 = setInterval(updateNumber2, 100);
  });

  // Update the number
  function updateNumber2() {
    let step2 = 1;
    if (counter2 + step2 >= percent2) {
      counter2 = percent2;
      $('#percentage2').html(counter2 + 'yrs+');
      clearInterval(intervalID2);
      return;
    }
    counter2 += step2;
    $('#percentage2',).html(counter2 + 'yrs+');
  }

  let percent3 = 90;
  let counter3 = 1;
  let intervalID3 = null;
  $(document).ready(() => {
    intervalID3 = setInterval(updateNumber3, 100);
  });

  // Update the number
  function updateNumber3() {
    let step3 = 5;
    if (counter3 + step3 >= percent3) {
      counter3 = percent3;
      $('#percentage3').html(counter3 + 'k');
      clearInterval(intervalID3);
      return;
    }
    counter3 += step3;
    $('#percentage3',).html(counter3 + 'k');
  }

  return (
    <>

      <section className="secintromain" id="home">

        <section className="bgimg" >
          <div className=" knownusheadv">

          </div>
        </section>

        {/* <section>
          <img src={adhibaban} className="w-100" style={{height:"630px", objectFit:"cover"}}/>
        </section> */}

        <div class="card-group  icongroup-section-adhiba">
          <div class="card iconimgtext" style={{ borderRadius: "10px" }}>
            <img class="service-image" src={iconsto} alt="brickwall" />
            <div class="">
              <h5 class="card-title text-center">Design</h5>
            </div>
          </div>
          <div class="card  iconimgtext" style={{ borderRadius: "10px" }}>
            <img class="service-image" src={icontec} alt="brickwall" />
            <div class="">
              <h5 class="card-title text-center">Development</h5>

            </div>

          </div>
          <div class="card iconimgtext" style={{ borderRadius: "10px" }}>
            <img class="service-image" src={iconpro} alt="brickwall" />
            <div class="">
              <h5 class="card-title text-center">Manufacturing</h5>

            </div>

          </div>
          <div class="card iconimgtext" style={{ borderRadius: "10px" }}>
            <img class="service-image" src={iconsolu} alt="brickwall" />
            <div class="">
              <h5 class="card-title text-center">Procurement</h5>

            </div>

          </div>
          <div class="card iconimgtext" style={{ borderRadius: "10px" }}>
            <img class="service-image" src={iconblog} alt="brickwall" />
            <div class="">
              <h5 class="card-title text-center">Delivery</h5>

            </div>

          </div>
        </div>


      </section>

      <section className="secintromain" id="blog">

        {/* <Timeline /> */}

        {/* <AdvancedTimeline /> */}

        <Newtimeline />

        <section className='bgfpc'>
          <div id="orange-sectionmain3">
            <h2 id="orange-section-title">COMPLETE SOLUTIONS TAILORED TO YOUR NEEDS</h2>
            <p id="orange-section-desc">From concept to delivery, we ensure excellence.</p>
            <button className="disbtn1-white">
              <a class="disbtn1-white-arrow-btn">LEARN MORE</a>
            </button>
          </div>
        </section>
        <Tabs />
        <section className='bgfpc'>
          <div id="orange-sectionmain2">
            <h2 id="orange-section-title">QUALITY DRIVEN PROCESSES, TRUSTED BY CLIENTS</h2>
            <p id="orange-section-desc">We follow strict standards for reliable outcomes.</p>
            <button className="disbtn1-white">
              <a class="disbtn1-white-arrow-btn">OUR PROCESS</a>
            </button>
          </div>
        </section>
      </section>

      <section className="secintromainsolution mb-5" id="ourbus">
        <h3 className="mt-5 mb-4">LET'S MAKE SOMETHING GREAT TOGETHER</h3>
        <div class="lets-make-card-group-adhiba">
          <div class="card card1 iconimgtext" style={{ borderRadius: "10px" }}>
            <img class="service-image" src={letmakesomimg1} alt="brickwall" />
            <div class="card-contents">
              <p class="service-title">PRODUCT</p>
              <p class="service-desc">We offer a wide range of high-quality electronics, including security and home automation solutions under Nystai. </p>
              <button className="disbtn1">
                <a class="arrow-btn" >DISCOVER MORE</a>
              </button>
            </div>
          </div>
          <div class="card card1 iconimgtext" style={{ borderRadius: "10px" }}>
            <img class="service-image" src={letmakesomimg2} alt="architecture" />
            <div class="card-contents">
              <p class="service-title"> PROCUREMENT </p>
              <p class="service-desc">Global procurement services sourcing electronic components and products, ensuring quality, cost-efficiency, and timely delivery. </p>
              <button className="disbtn1">
                <a class="arrow-btn" >DISCOVER MORE</a>
              </button>
            </div>
          </div>
          <div class="card card1 iconimgtext" style={{ borderRadius: "10px" }}>
            <img class="service-image" src={letmakesomimg3} alt="construction" />
            <div class="card-contents">
              <p class="service-title">DESIGN</p>
              <p class="service-desc">Custom electronics design services tailored to your needs, from concept to prototype with cutting-edge technology. </p>
              <button className="disbtn1">
                <a class="arrow-btn" >DISCOVER MORE</a>
              </button>
            </div>
          </div>
          <div class="card card1 iconimgtext" style={{ borderRadius: "10px" }}>
            <img class="service-image" src={letmakesomimg4} alt="financial results" />
            <div class="card-contents">
              <p class="service-title">MANUFACUTURING</p>
              <p class="service-desc">End-to-end electronics manufacturing capabilities, producing reliable, high-performance products with precision and quality assurance. </p>
              <button className="disbtn1">
                <a class="arrow-btn" >DISCOVER MORE</a>
              </button>
            </div>
          </div>
          <div class="card card1 iconimgtext" style={{ borderRadius: "10px" }}>
            <img class="service-image" src={letmakesomimg5} alt="financial results" />
            <div class="card-contents">
              <p class="service-title">TURN KEY</p>
              <p class="service-desc">Complete turnkey solutions, from initial design to final product delivery, providing seamless integration and support.</p>
              <button className="disbtn1">
                <a class="arrow-btn" >DISCOVER MORE</a>
              </button>
            </div>
          </div>
        </div>

      </section>

      <section className="secintromain" id="photos">
        <section className='bgfpc'>
          <div id="orange-sectionmain">
            <h2 id="orange-section-title">INNOVATIVE IDEAS THAT SHAPE THE FUTURE</h2>
            <p id="orange-section-desc">We create smarter solutions for every challenge.</p>
            <button className="disbtn1-white">
              <a class="disbtn1-white-arrow-btn">DISCOVER MORE</a>
            </button>
          </div>
        </section>

        {/* <Productcardcar /> */}

      </section>

      <section className="container-fluid solusecmain mt-5 mb-5" id="newsletter">

        <h1 className=" soltexth text-center mb-4">All-around solutions for
          varied needs</h1>

        <div class="card-group">
          <div class=" card m-2" style={{ borderRadius: "20px" }}>
            <img src={soluimg} class="img-fluid p-3  " />
            <div class="card-body">
              <h5 class="card-title">Strategy</h5>
              <p class="card-text">We plan every project with precision, aligning timelines, resources, and cost efficiency.  </p>
              <button className="disbtn1">
                <a class="arrow-btn" >Explore</a>
              </button>
            </div>
          </div>
          <div class="card m-2" style={{ borderRadius: "20px" }}>
            <img src={soluimg2} class="img-fluid p-3" />
            <div class="card-body">
              <h5 class="card-title">Execution</h5>
              <p class="card-text">Turning concepts into reality through detailed development and high-precision manufacturing methods.</p>
              <button className="disbtn1">
                <a class="arrow-btn">View Work</a>
              </button>
            </div>
          </div>
          <div class="card m-2" style={{ borderRadius: "20px" }}>
            <img src={soluimg3} class="img-fluid p-3" />
            <div class="card-body">
              <h5 class="card-title">Support</h5>
              <p class="card-text">End-to-end assistance—from sourcing to delivery, ensuring a seamless project experience.</p>
              <button className="disbtn1">
                <a class="arrow-btn">Get Help</a>
              </button>
            </div>
          </div>
        </div>

      </section>

      <section className="" id="contact">

        <NysCaro />

        <div class="card-group icongroup">
          <div class="card card1 iconimgtext" style={{ borderRadius: "10px" }}>

            <div class="text-center">

              <h1 className="" id='percentage'>0k</h1>
              <h6 className="" >PROJECTS COUNT</h6>

            </div>

          </div>
          <div class="card card1 iconimgtext" style={{ borderRadius: "10px" }}>

            <div class="text-center">
              <h1 className="" id='percentage2'>0%</h1>
              <h6 className="" >YEARS IN FEILD</h6>
            </div>

          </div>
          <div class="card card1 iconimgtext" style={{ borderRadius: "10px" }}>

            <div class="text-center">
              <h1 className="" id='percentage3'>0% </h1>
              <h6 className="" >DEVICE COUNT</h6>
            </div>

          </div>


        </div>

        <Footer />
      </section>

    </>
  )
}